export default __webpack_public_path__ + "static/media/video-games.641bd665.png";